// AI-Office UTM tracker. При загрузке страницы с ?utm_idea=<uuid> шлёт
// fire-and-forget GET на /utm-pixel у бота — bot пишет touchpoint
// (channel='utm_link', event_name='utm_click', payload.utm_idea=<id>).
// OutcomeTracker потом считает клики на конкретную идею.

const STORAGE_KEY = 'utm_idea_pinged';
const ID_RE = /^[0-9a-f-]{36}$/i;

export function trackUtmIdea() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const ideaId = params.get('utm_idea');
  if (!ideaId || !ID_RE.test(ideaId)) return;

  // Один пинг на сессию — защита от двойных вызовов в StrictMode и SPA-навигации.
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === ideaId) return;
    sessionStorage.setItem(STORAGE_KEY, ideaId);
  } catch {
    // sessionStorage может быть запрещён — продолжаем без guard'а.
  }

  const botUrl = (import.meta.env.VITE_ADMIN_BOT_URL || '').replace(/\/$/, '');
  if (!botUrl) return;

  const source = params.get('utm_source') || 'ai_office';
  const url = `${botUrl}/utm-pixel?idea=${encodeURIComponent(ideaId)}&source=${encodeURIComponent(source)}`;

  // Используем Image-pixel вместо fetch — обходит CORS и не зависит от
  // mode: 'no-cors' нюансов. Запрос летит на бот, ответ нам не нужен.
  try {
    const img = new Image();
    img.referrerPolicy = 'no-referrer-when-downgrade';
    img.src = url;
  } catch {}
}
